var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.$style.app},[_c('app-egrn-free-form',{attrs:{"get-products":_vm.getProducts}}),_c('app-dialog-root')],1)}
var staticRenderFns = []

export { render, staticRenderFns }